import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=64b2ab4c&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=64b2ab4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b2ab4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64b2ab4c')) {
      api.createRecord('64b2ab4c', component.options)
    } else {
      api.reload('64b2ab4c', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=64b2ab4c&scoped=true&", function () {
      api.rerender('64b2ab4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2qZvWAsjmm08N/JS/comp/PopupBox.vue"
export default component.exports